import type {LayoutPayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {budgetThresholdBannerQuery} from '../queries/budget-threshold-banner-query'

export function buildCodeViewLayoutRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewLayoutRoute', {
    path: '/:owner/:repo',
    queries: [
      mainQuery<LayoutPayload>({
        queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
      }),
      budgetThresholdBannerQuery,
    ],
    shouldRevalidate: ({currentParams, nextParams}) => {
      return currentParams.owner !== nextParams.owner || currentParams.repo !== nextParams.repo
    },
    tanStackRouterOptions: {
      // React Router's shouldRevalidate can't be automatically adapted for TanStack Router.
      // That's fine here: it only guards param changes, and TSR reloads on param change automatically.
      // This noop satisfies the TSR adapter's requirement that shouldRevalidate be manually reviewed.
      shouldReload: undefined,
    },
  })
}

export const codeViewLayoutRoute = buildCodeViewLayoutRoute(codeViewAppBuilder)
